import downloadjs from "downloadjs";
import * as React from "react";
import MessageListLine from "source/components/framework/Message/MessageLine/MessageLine";
import { Translations } from "ui/Scripts/source/models/translations";
import { IWhistleBlowEditItemMessage } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditItemMessage";
import { AppUtils } from "../../../framework/appUtils";
import * as attachmentService from "../../../models/services/attachmentService";

//WhistleBlowEditDialogMessageListLine
export interface IWhistleBlowEditDialogMessageListLineProp {
    observer: IntersectionObserver;
    message: IWhistleBlowEditItemMessage;
    selectedId: string;
    onClick: (id: string) => void;
}

export class WhistleBlowEditDialogMessageListLine extends React.Component<IWhistleBlowEditDialogMessageListLineProp, {}> {
    private observer: IntersectionObserver = null;
    private lineDiv = React.createRef<HTMLDivElement>();

    registerToObserver = () => {
        const props = this.props;
        if (!props.observer || !this.lineDiv || !props.message || props.message.myMessage) return;
        this.observer = props.observer;
        this.observer.observe(this.lineDiv.current);
    };

    unregisterFromObserver = () => {
        if (!this.observer || !this.lineDiv) return;
        this.observer.unobserve(this.lineDiv.current);
    };

    componentDidMount(): void {
        this.registerToObserver();
    }

    componentDidUpdate(prevProps: IWhistleBlowEditDialogMessageListLineProp) {
        const props = this.props;
        const prevObserverExists = !!prevProps.observer;
        const observerExists = !!props.observer;
        if (prevObserverExists === observerExists) return;
        this.unregisterFromObserver();
        if (observerExists) {
            this.registerToObserver();
        }
    }

    componentWillUnmount(): void {
        this.unregisterFromObserver();
    }

    handleAttachmentClick = async (id: string) => {
        if (!id) return;
        const props = this.props;
        const attachment = props.message.attachments.find(i => i.id === id);
        if (!attachment) return;
        if (attachment.file) {
            downloadjs(attachment.file, attachment.name);
            return;
        }
        if (attachment.isNew()) return;
        const fileName = await AppUtils.callService(() => attachmentService.getAttachment(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };
    
    render() {
        const props = this.props;
        const message = props.message;
        return (
            <MessageListLine
                ref={this.lineDiv}
                id={message.id}
                content={message.content}
                attachments={message.attachments}
                date={message.date}
                myMessage={message.myMessage}
                sender={message.informantMessage ? Translations.WhistleBlowInformant : message.modifyUser.name}
                allRead={message.allRead}
                onClick={props.onClick}
            />
        );
    }
}